<template>
  <div id="app">
    <router-view v-if="visible"></router-view>
    <ActionSheet ref="actionSheet" />
    <InputPopup ref="inputPopup" />
  </div>
</template>
<script>
import ActionSheet from '@/components/ActionSheet.vue'
import InputPopup from '@/components/InputPopup.vue'
export default {
  name: 'App',
  components: {
    ActionSheet,
    InputPopup
  },
  data() {
    return {}
  },
  computed: {
    visible() {
      return !this.$route.meta.requireAuth || (this.$route.meta.requireAuth && this.vuex_userInfo)
    }
  },
  async created() {},
  methods: {}
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;
}

/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: 'iconfont'; /* Project id 4796014 */
  src: url('//at.alicdn.com/t/c/font_4796014_41yx5ffyioi.woff2?t=1775965479378') format('woff2'),
    url('//at.alicdn.com/t/c/font_4796014_41yx5ffyioi.woff?t=1775965479378') format('woff'),
    url('//at.alicdn.com/t/c/font_4796014_41yx5ffyioi.ttf?t=1775965479378') format('truetype');
}

.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;

  > .container {
    flex: 1;
    overflow: scroll;
    display: flex;
    flex-direction: column;
  }
}

.card {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.04);
  border: 1px solid #f1f1f1;
  border-radius: 15px;

  > .title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .left {
      flex: 1;
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }

    > .right {
      display: flex;
      gap: 10px;
    }
  }

  > .content {
    flex: 1;
    overflow: scroll;
  }
}

.m16 {
  margin: 16px;
}

.default-cover {
  width: 100%;
  height: 100%;
  background-color: #2b2b2b;
}
</style>
